export const enum EFullscreenEvent {
  Changed = 'Fullscreen:Changed'
}

export interface IFullscreen {
  readonly isInFullScreen: () => boolean
  readonly requestFullScreen: (isEnter?: boolean) => void
  readonly toggleFullScreen: (lockDuration?: number) => void
  readonly isSupported: () => boolean
  readonly off: () => void
  readonly on: () => void
}
